import React, { useEffect, useRef } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';

const createRotatedIcon = (bearing) => {
    return L.divIcon({
        className: 'user-marker-icon',
        html: `<div style="transform: rotate(${bearing}deg); width: 32px; height: 32px; display: flex; justify-content: center; align-items: center;">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M12 2L4.5 20.29C4.21 21 4.99 21.71 5.66 21.33L12 17.69L18.34 21.33C19.01 21.71 19.79 21 19.5 20.29L12 2Z" fill="#2196F3" stroke="white" stroke-width="2"/>
                 </svg>
               </div>`,
        iconSize: [32, 32],
        iconAnchor: [16, 16], // Center of the icon
    });
};

export const UserMarker = ({ position, bearing, draggable, eventHandlers }) => {
    const markerRef = useRef(null);

    useEffect(() => {
        if (markerRef.current) {
            const icon = createRotatedIcon(bearing);
            markerRef.current.setIcon(icon);
        }
    }, [bearing]);

    return (
        <Marker
            ref={markerRef}
            position={position}
            icon={createRotatedIcon(bearing)}
            draggable={draggable}
            eventHandlers={eventHandlers}
        />
    );
};
